import { Pipe, PipeTransform } from '@angular/core';
import { OperatorDisplayMap } from 'tsui';

@Pipe({ name: 'operatorToDisplayString' })
export class OperatorToDisplayStringPipe implements PipeTransform {
  transform(value: string): any {
    return OperatorDisplayMap[value] ?? value;
  }
}
